// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2220": "063a1cbfda0e","2820": "b6025241b1d2","6863": "454c9f289029","7604": "c0638b316d08",}[chunkId] + ".css"
}